module.exports = __webpack_public_path__ + "media/images/application/template/flag-nz-099d7f5ed8c7581bfafb787ea9221000.png";